// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8fda3cc2","732":"e698721e","977":"5af8c61f"}[chunkId] + ".chunk.js";
};